import React, { useContext } from "react";
import { AppStore } from "../../app/store";
import { Plan } from "../../@types";
import { PlanHeader } from "../../components";
import Details from "./PDPPlanDetailSections";
import { hasAbstractBenefits } from "./AbstractBenefits/AbstractBenefitsHelpers";
import { PreviewContext, useCosts } from "../../helpers";

const PDPPlanDetails: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const {
    state: { prescriptions },
  } = useContext(AppStore.AppContext);
  const drugCostInfo = useCosts(plan);
  const previewMode = useContext(PreviewContext);

  return (
    <article>
      <PlanHeader plan={plan} />
      <div
        className={`PlanDetails__contentContainer${
          previewMode ? " preview-mode" : ""
        }`}
      >
        {!previewMode && (
          <Details.Navigation
            hasAbstractBenefits={hasAbstractBenefits(plan)}
            hasDrugs={prescriptions.length > 0}
            hasDrugCosts={!!drugCostInfo.costs.length}
          />
        )}

        <div className="plan-details-content">
          <Details.Overview plan={plan} />

          <Details.DrugCoverage plan={plan} drugCostInfo={drugCostInfo} />

          {!previewMode && <Details.StarRatings plan={plan} />}

          <Details.DocumentsAndContact plan={plan} />
        </div>
      </div>
    </article>
  );
};

export default PDPPlanDetails;
